var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52623 18.608L6.09423 18.0329C5.71466 17.5274 4.90866 17.5682 4.58803 18.1089C4.13806 18.8678 2.91663 18.5654 2.91663 17.6951V3.94132C2.91663 3.07103 4.13806 2.76862 4.58803 3.52749C4.90866 4.06822 5.71466 4.10893 6.09423 3.60357L6.52623 3.02838C7.07052 2.30369 8.20718 2.30369 8.75146 3.02838L8.81938 3.11883C9.39696 3.88777 10.603 3.88777 11.1805 3.11883L11.2485 3.02838C11.7927 2.30369 12.9294 2.30369 13.4737 3.02838L13.9057 3.60357C14.2853 4.10893 15.0913 4.06822 15.4119 3.52749C15.8619 2.76862 17.0833 3.07103 17.0833 3.94132V17.6951C17.0833 18.5654 15.8619 18.8678 15.4119 18.1089C15.0913 17.5682 14.2853 17.5274 13.9057 18.0329L13.4737 18.608C12.9294 19.3327 11.7927 19.3327 11.2485 18.608L11.1805 18.5175C10.603 17.7486 9.39696 17.7486 8.81938 18.5175L8.75146 18.608C8.20718 19.3327 7.07052 19.3327 6.52623 18.608Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.31818L7.5 13.3182",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.3182H12.4925M7.50748 8.31818H7.5",
    stroke: "#F1F1F1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.711979487d0da0a0543fdd0e8d786dda.svg";
export { ForwardRef as ReactComponent };